import toXlsx from './toXlsx'

export default function downloadAsExcel({columns, data, filename}) {
  const headings = columns && columns
    .filter(heading => typeof heading === 'string' || (heading.options && heading.options.download))
    .map(heading => typeof heading === 'string' ? heading : heading.name)
  let html = `<table><tbody>\n<tr><th>${headings && headings.join('</th><th>')}</th></tr>\n`
  html += data ? data.map(row => `<tr><td>${row.join('</td><td>')}</td></tr>`).join('\n') + '</tbody></table>\n' : ''
  toXlsx(html, filename || 'results')
}